import { useLayoutEffect } from "react";
import { renderNumberValue, replaceD3FormatSpecialChars } from "utils/string";
const MAX_PLOT_AXES = 12;
const XYTickClasses = Array.from(Array(MAX_PLOT_AXES)).reduce((arr, _, i) => [...arr, `x${i ? i + 1 : ""}tick`, `y${i ? i + 1 : ""}tick`], []);
const roundTicksValue = (records) => {
    const filteredRecords = records.filter(({ target, type }) => {
        const classList = target.classList;
        if (!classList || type !== "childList" || target.nodeName !== "g") {
            return false;
        }
        else {
            return XYTickClasses.some((classname) => classList.contains(classname));
        }
    });
    filteredRecords.forEach(({ addedNodes }) => addedNodes.forEach((element) => {
        if (element.textContent) {
            const tickValue = +replaceD3FormatSpecialChars(element.textContent);
            const calculatedValue = renderNumberValue(tickValue, { transformIndex: 5 });
            if (tickValue && calculatedValue) {
                element.innerHTML = calculatedValue;
            }
        }
    }));
};
const roundTicksValueObserver = (graphDiv) => {
    let observer;
    if (graphDiv) {
        observer = new MutationObserver((records) => {
            return roundTicksValue(records);
        });
        observer.observe(graphDiv, { childList: true, subtree: true });
    }
    return observer;
};
const useRoundTickValueObserver = (ref) => {
    useLayoutEffect(() => {
        const observer = roundTicksValueObserver(ref?.current?.el);
        return () => observer?.disconnect();
    }, [ref]);
};
export default useRoundTickValueObserver;
